'use strict';

import util from './util';

function countrySelector() {
    const $countriesSelector = $('.countries-selector'),
        $goButton = $('.go-button');

    $countriesSelector.on('change', function(e) {
        e.preventDefault();
    })
    .on('focus', e => {
        e.preventDefault();
        $goButton.show();
    });

    $goButton.on('click', e => {
        e.preventDefault();

        var countrySelected = $countriesSelector.find(':selected').text().toLowerCase();
        if (countrySelected == 'us' || countrySelected == 'united states') {
        	return false;
        }

        var countryUrl = $countriesSelector.find(':selected').val();
        document.location.href = countryUrl;
    })
    .on( "focusout", e => {
        $goButton.hide();
    });
}

export default { countrySelector };